import type { ClientInstrumentation } from 'react-router'

import { getRum } from './instrumentation.client'

// React Router client Instrumentation API (GA in 7.17.0) — wraps client-side
// navigations and fetcher loads to emit RUM custom actions carrying the actual
// client-side data-load duration + outcome, which raw RUM view timing alone
// doesn't isolate.
//
// A no-op until RUM is live: getRum() returns undefined outside production, and
// RR catches any error thrown inside these callbacks, so this cannot break the app.
//
// Note (7.17.0): navigate/fetch info lacks `meta.pattern` (v8.1.0-only), so RUM
// views are named by URL path, not route pattern (tunable later — separate issue).
export const rumInstrumentation: ClientInstrumentation = {
  router(router) {
    router.instrument({
      async navigate(next, { to, currentUrl }) {
        const start = performance.now()
        const { status } = await next()
        getRum()?.addAction('react_router.navigate', {
          to: String(to),
          from: currentUrl,
          outcome: status,
          durationMs: Math.round(performance.now() - start),
        })
      },
      async fetch(next, { href, fetcherKey }) {
        const start = performance.now()
        const { status } = await next()
        getRum()?.addAction('react_router.fetch', {
          href,
          fetcherKey,
          outcome: status,
          durationMs: Math.round(performance.now() - start),
        })
      },
    })
  },
}
